import React from 'react';
import '../styles/SimpleFooter.css';

const SimpleFooter = () => {
  return (
    <footer className="simple-footer">
      <div className="simple-footer-container">
      </div>
    </footer>
  );
};

export default SimpleFooter;


